(function(){
  "use strict";
  var money = function(c){ try{ return (c/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'});}catch(e){return '$'+(c/100).toFixed(2);} };

  function on(sel,evt,fn,root){(root||document).querySelectorAll(sel).forEach(function(el){el.addEventListener(evt,fn);});}

  /* Mobile menu */
  var mm=document.querySelector('[data-mobile-menu]');
  on('[data-menu-open]','click',function(){if(mm)mm.classList.add('is-open');});
  on('[data-menu-close]','click',function(){if(mm)mm.classList.remove('is-open');});

  /* Accordion */
  document.querySelectorAll('[data-accordion] .accordion__item').forEach(function(item){
    var head=item.querySelector('.accordion__head'),panel=item.querySelector('.accordion__panel');
    if(!head||!panel)return;
    head.addEventListener('click',function(){
      var open=item.classList.toggle('is-open');
      head.setAttribute('aria-expanded',open);
      panel.style.maxHeight=open?panel.scrollHeight+'px':null;
    });
  });

  /* Qty stepper */
  document.querySelectorAll('.qty-stepper').forEach(function(st){
    var input=st.querySelector('input');
    st.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(input.value||'1',10)+parseInt(b.getAttribute('data-qty'),10);
        input.value=Math.max(1,v);
      });
    });
  });

  /* Product gallery thumbs */
  var mainImg=document.getElementById('ProductMainImage');
  on('.product-gallery__thumb','click',function(){
    if(mainImg)mainImg.src=this.getAttribute('data-thumb');
  });

  /* Cart drawer */
  var drawer=document.getElementById('cart-drawer'),
      body=drawer&&drawer.querySelector('[data-cart-body]'),
      counts=document.querySelectorAll('[data-cart-count]');

  function openDrawer(){if(drawer){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');}}
  function closeDrawer(){if(drawer){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');}}
  on('[data-cart-close]','click',closeDrawer);

  function setCount(n){counts.forEach(function(c){c.textContent=n;});}

  function renderCart(cart){
    if(!body)return;
    if(!cart.items||!cart.items.length){body.innerHTML='<p style="color:#5a655f">'+(window.__afyaEmptyCart||'Votre panier est vide.')+'</p>';return;}
    var html='<div class="cart-drawer__items">';
    cart.items.forEach(function(it){
      html+='<div class="cart-item" style="grid-template-columns:60px 1fr auto">'+
        '<a href="'+it.url+'" class="cart-item__media">'+(it.image?'<img src="'+it.image+'" alt="">':'')+'</a>'+
        '<div class="cart-item__info"><a href="'+it.url+'">'+it.product_title+'</a><span class="cart-item__price">'+money(it.final_price)+' &times; '+it.quantity+'</span></div>'+
        '<span class="cart-item__line">'+money(it.final_line_price)+'</span></div>';
    });
    html+='</div><div class="cart-footer" style="align-items:stretch">'+
      '<div class="cart-subtotal" style="justify-content:space-between"><span>Sous-total</span><strong>'+money(cart.total_price)+'</strong></div>'+
      '<a href="/cart" class="btn btn--ghost btn--block" style="margin-top:8px">Voir le panier</a>'+
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn--primary btn--block btn--lg" style="margin-top:8px;width:100%">Passer la commande</button></form></div>';
    body.innerHTML=html;
  }

  function refreshCart(open){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);renderCart(cart);if(open)openDrawer();
    });
  }

  /* AJAX add to cart */
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(form.matches('form[action$="/cart/add"], .product-form, .product-card__form')){
      var btn=form.querySelector('[data-add-to-cart]');
      if(!btn)return;
      e.preventDefault();
      var data=new FormData(form);
      btn.disabled=true;var orig=btn.textContent;btn.textContent='…';
      fetch('/cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(){refreshCart(true);})
        .catch(function(){form.submit();})
        .finally(function(){btn.disabled=false;btn.textContent=orig;});
    }
  });

  document.querySelectorAll('[data-cart-open]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();refreshCart(true);});
  });

  if(counts.length)refreshCart(false);
})();
